import { ReactElement, FC, memo } from 'react';

import { Box, Text, Stack, Flex, Title, Group } from '@ui';

interface FeatureProps {
  title?: string;
  description?: string;
  descriptionVariant?: 'subtitle1' | 'body1';
  customDescription?: ReactElement;
  Img?: any;
}

const Feature: FC<FeatureProps> = memo(
  ({
    title,
    description,
    descriptionVariant,
    customDescription,
    Img
  }: FeatureProps) => {
    return title ? (
      <Stack m={2} display="flex" justify="center" align="center">
        <Box visibleFrom="sm" ta="center">
          <Flex justify="center" mb={16}>
            {!Img ? (
              <Box style={{ width: 72, height: 72, backgroundColor: 'lightgray' }} />
            ) : (
              <Img height={72} width={72} />
            )}
          </Flex>
          <Title variant="h6" ta="center" mb="xs" fz={20} fw={700}>
            {title}
          </Title>
          {!customDescription ? (
            <Text
              // variant={!descriptionVariant ? 'body1' : descriptionVariant}
              ta="center"
              c="secondary"
              fz={16}
              fw={400}
            >
              {description}
            </Text>
          ) : (
            customDescription
          )}
        </Box>
        <Box hiddenFrom="sm">
          <Flex justify="center" mb={16}>
            {!Img ? (
              <Box style={{ width: 36, height: 36, backgroundColor: 'lightgray' }} />
            ) : (
              <Img height={36} width={36} />
            )}
          </Flex>
          <Text variant="h6" ta="center" mb={16}>
            {title}
          </Text>
          {!customDescription ? (
            <Text
              variant={!descriptionVariant ? 'body1' : descriptionVariant}
              ta="center"
              c="gray"
            >
              {description}
            </Text>
          ) : (
            customDescription
          )}
        </Box>
      </Stack>
    ) : (
      <Box mt={10}>
        <Group justify="flex-start" align="flex-start">
          <Box mr={20}>
            <Box style={{ width: 24, height: 24, backgroundColor: 'lightgray' }} />
          </Box>
          {!customDescription ? (
            <Text
              variant={!descriptionVariant ? 'body1' : descriptionVariant}
              c="gray"
            >
              {description}
            </Text>
          ) : (
            customDescription
          )}
        </Group>
      </Box>
    );
  }
);

export { Feature };
